import { Link } from 'react-router-dom';
import styled from 'styled-components';

const CustomLink = styled(Link)<{ fontSize?: string; color?: string }>`
  text-decoration: underline;
  color: ${({ color, theme }) => color || theme.colors.primary};
  font-size: ${({ fontSize }) => fontSize || 'inherit'};
`;

export function StyledLink({
  path,
  children,
  fontSize,
  target,
  color,
  state,
}: {
  path: string;
  children: React.ReactNode;
  fontSize?: string;
  target?: string;
  color?: string;
  state?: any;
}) {
  return (
    <CustomLink
      to={path}
      fontSize={fontSize}
      target={target}
      state={state}
      color={color}
    >
      {children}
    </CustomLink>
  );
}
